import React from 'react';
import { ListItem, ListItemText, MenuItem, Menu, Link } from '@material-ui/core';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { connect } from 'react-redux';
import * as DevToolActions from 'app/actions/dev-tool/actions';

interface PropertyInfoTestCase {
  propertyStreet   : string;
  propertyStreet2? : string;
  propertyCity     : string;
  propertyState    : string;
  propertyZip      : string;
}

const testCaseOne: PropertyInfoTestCase = {
  propertyStreet  : '1552 Virginia Park St',
  propertyCity    : 'Detroit',
  propertyState   : 'MI',
  propertyZip     : '48206',
};

const options = [
  { label: 'No Test Case Selected', value: {} },
  { label: 'MI State / $130,000 Valuation', value: testCaseOne },
];

class DevCreditPull extends React.Component<any, any> {
  state = {
    anchorEl     : null,
    selectedIndex: 0,
  };

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.setCreditPullTestCase(options[index].value);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <ListItem
          button
          aria-haspopup = 'true'
          aria-controls = 'lock-menu'
          aria-label    = 'Property Info Test Case'
          onClick       = {this.handleClickListItem}
        >
          <ListItemText
            primary   = 'Property Info Test Case'
            secondary = {options[this.state.selectedIndex].label}
          />
        </ListItem>
        <Menu
          id       = 'lock-menu'
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          onClose  = {this.handleClose}
        >
          {options.map((option, index) => {
            return (
              <MenuItem
                disabled = {index === 0}
                key      = {option.label}
                onClick  = {event => this.handleMenuItemClick(event, index)}
                selected = {index === this.state.selectedIndex}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
        <Link href='https://estated.com/developers/docs/v4/sandbox/api'
          style={{ fontSize: 14, marginLeft: 15 }}
          target='_blank'
          rel='noreferrer'
        >
          More Property Examples <OpenInNew style={{ fontSize: 12 }}/>
        </Link>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = DevToolActions;
export default connect(null, mapDispatchToProps)(DevCreditPull);
